export default import.meta.ROLLDOWN_FILE_URL_N5Ny3wzSDgsXWrbrPUpL0g